<app-spinner></app-spinner>
<div class="wrapper">
    <nav class="navbar navbar-expand navbar-primary navbar-dark">
        <a class="navbar-brand" href="">
            <!-- <img src="assets/img/icon-logo.png" width="30" height="30" class="d-inline-block align-top" alt=""> -->
            <h4 class="ml-3 font-weight-bold mb-0">eContract</h4>
        </a>
    </nav>

    <div #contentWrapper class="wrapper">
        <section class="content">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <section class="col-lg-5 col-md-7 col-sm-9">
                        <div class="content-step-card">
                            <div class="content-step">
                                <ul class="stepbar">
                                    <li [class.done]="stepControl[0].done" [class.active]="currentStep === 0">{{ 'ServiceSignUpV2StepTwo_chon_loai_khach_hang' | translate }}</li>
                                    <li [class.done]="stepControl[1].done" [class.active]="currentStep === 1">{{ 'ServiceSignUpV2StepTwo_thong_tin_dang_ky' | translate }}</li>
                                    <li [class.done]="stepControl[2].done" [class.active]="currentStep === 2">{{ 'ServiceSignUpV2StepTwo_xac_minh_tai_khoan' | translate }}</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="row justify-content-center mt-3">
                    <div class="col-lg-6 col-md-8 col-sm-10 tab-step fade show" [class.d-none]="currentStep !== 0">
                        <app-signup-v2-step-one (next)="handleNext($event, 0)"></app-signup-v2-step-one>
                    </div>

                    <div class="col-md-5 tab-step fade show" [class.d-none]="currentStep !== 1">
                        <app-signup-v2-step-two [userType]="dataForm.userType || ''" (next)="handleNext($event, 1)" (back)="handleBack($event, 1)"></app-signup-v2-step-two>
                    </div>

                    <div class="col-md-5 tab-step fade show" [class.d-none]="currentStep !== 2">
                        <app-signup-v2-step-three [id]="dataForm.userId || ''" [userType]="dataForm.userType || ''" [dataForm]="dataForm" (next)="handleNext($event, 2)"></app-signup-v2-step-three>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<div id="ppi" style="height: 1in; width: 1in; position: absolute; top: -100%; left: -100%;"></div>